import {CanActivateChildFn, Router} from '@angular/router';
import {inject, Signal} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {User} from 'patja-api';
import {firstValueFrom} from 'rxjs';
import {RoutePaths} from '../../app.routes';

export const isUsingAccountingMaterialGuard: CanActivateChildFn = async () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const user: Signal<User | null> = await firstValueFrom(authService.getUser());

  //Customers cannot access accounting material
  if (user()?.isCustomer()) {
    await router.navigateByUrl(RoutePaths.Home);
    return false;
  }

  if (user()?.useAccountingMaterial) {
    return true;
  }

  await router.navigateByUrl(RoutePaths.Home);
  return false;
};
